import React, {Component} from 'react';
import PropTypes from "prop-types";
import moment from 'moment';
import EditQuizQuestionModal from './FormModals/EditQuizQuestionModal'
import SortableQuiz from './SortableQuiz';
import CsvParse from '@vtex/react-csv-parse';
import CsvDownloader from 'react-csv-downloader';
import { Scrollbars } from 'react-custom-scrollbars';

/* global $ */

class EditQuizQuestions extends Component {
    state = {
        showAddQuizModal: false,
        showEditQuizModal: false,
        showUploadModal: false,
        deleteModalIsOpen: false,
        selectedQuizQuestionId: '',
        uploadQuestions: []
    };
    
    keys = [
        "question",
        "optionA",
        "optionB",
        "optionC",
        "optionD",
        "correctOption",
        "conceptName",
        "timeInVideo",
        "conceptRefersTo"
        ]
    columns = [{
        id: 'question',
        displayName: 'Question'
      }, {
        id: 'optionA',
        displayName: 'Option A'
      }, {
        id: 'optionB',
        displayName: 'Option B'
      }, {
        id: 'optionC',
        displayName: 'Option C'
      }, {
        id: 'optionD',
        displayName: 'Option D'
      }, {
        id: 'correctOption',
        displayName: 'Correct Option'
      }, {
        id: 'conceptName',
        displayName: 'Concept Name'
      }, {
        id: 'timeInVideo',
        displayName: 'Time In Video'
      }, {
        id: 'conceptRefersTo',
        displayName: 'Concept Refers To'
      }, {
        id: 'number',
        displayName: 'Number'
      }];

    //LifecycleMethods
    componentDidMount() {
        this.props.onLoad();
    }
    
    handleData = data => {
        data = data.map((d, i) => {
            return {
                ...d,
                timeInVideo: d.timeInVideo ? d.timeInVideo : 0,
                conceptName: d.conceptName ? d.conceptName : '',
                conceptRefersTo: d.conceptRefersTo ? d.conceptRefersTo : '',
                correctOption: !isNaN(d.correctOption) ? Number(d.correctOption) : 0,
                chapterVideoId: this.props.chapterVideoId,
                number: i
            
            }
        })
      this.setState({ uploadQuestions: data })
    }
    
    handleQuestionUpload = () => {
        let {uploadQuestions} = this.state;
        uploadQuestions = uploadQuestions.map((q, i) => {
            return {
                ...q,
                number: this.props.questions.length + i
            }
        })
        
        uploadQuestions.map(q => {
            return this.props.saveQuizQuestion(q, [], this.props.user.id);
        })
        
        this.setState({showUploadModal: false, uploadQuestions: []});
    }

    //Actions
    handleDeleteModalShowState = (idDelete, e) => {
        e.preventDefault();
        this.setState({
            deleteModalIsOpen: !this.state.deleteModalIsOpen,
            selectedQuizQuestionId: idDelete || ''
        });
    };

    handleQuizQuestionDelete = (idDelete, e) => {
        e.preventDefault();
        this.setState({
            deleteModalIsOpen: !this.state.deleteModalIsOpen,
        });
        this.props.onQuizQuestionDelete(idDelete);
    };

    handleRewindTo = (time) => {
        this.props.getTimeToRewind(time);
    };

    triggerAddQuestionShowState = () => {
        this.setState({
            selectedQuizQuestionId: null,
            showEditQuizModal: !this.state.showEditQuizModal
        });
    };

    triggerEditQuestionShowState = () => {
        this.setState({
            showEditQuizModal: !this.state.showEditQuizModal
        });
    };

    handleEditQuestionClick = (id) => {
        this.setState({
            selectedQuizQuestionId: id,
        });
        this.triggerEditQuestionShowState();
    };

    //Renders
    renderQuizQuestionsItems = () => {
        const isEditedInPreview = this.props.isEditedInPreview;    
        
        return (
            <SortableQuiz
                questions={this.props.questions}
                handleEditQuestionClick={this.handleEditQuestionClick}
                handleDeleteModalShowState={this.handleDeleteModalShowState}
                handleRewindTo={this.handleRewindTo}
                isEditedInPreview={isEditedInPreview}
                updateQuestionNumbers={this.props.updateQuestionNumbers}
                
            />
        )
        
    };

    renderDeleteModal = (idDelete) => (
        <div className='delete-modal-wrapper bootbox modal fade bootbox-confirm in'>
            <div className="modal-dialog modal-sm">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={(e) => this.handleDeleteModalShowState(null, e)}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <div className="sp-10 font-16">
                                Do you really want to remove this question?
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={(e) => this.handleDeleteModalShowState(null, e)}
                        >
                            CANCEL
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={(e) => this.handleQuizQuestionDelete(idDelete, e)}
                        >
                            DELETE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
    
    renderUploadModal = () => {
        return (
            <div className='delete-modal-wrapper bootbox modal fade bootbox-confirm in'>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={(e) => this.setState({showUploadModal: false, uploadQuestions: []})}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <h4 className="modal-title">Import Quiz Questions</h4>
                            <Scrollbars style={{ height: "80vh", overflow: "hidden"}}>
                            <div className="sp-10 font-16 modalScroll">
                                {this.state.uploadQuestions.length === 0 &&
                                    <CsvParse
                                      keys={this.keys}
                                      onDataUploaded={this.handleData}
                                      onError={this.handleError}
                                      render={onChange => (
                                            <div className="upload-body">
                                                <button className="btn btn-primary" onClick={e => {
                                                    $('#qqu').trigger('click');
                                                }}
                                                ><i className="zmdi zmdi-upload" /> &nbsp; Select File</button>
                                                <input id="qqu" type="file" onChange={onChange} className="hide" />
                                            </div>
                                        )
                                      }
                                    />
                                }
                                <SortableQuiz
                                    questions={this.state.uploadQuestions}
                                    handleEditQuestionClick={this.handleEditQuestionClick}
                                    handleDeleteModalShowState={this.props.handleDeleteModalShowState}
                                    handleRewindTo={this.handleRewindTo}
                                    isEditedInPreview={this.state.isEditedInPreview}
                                    updateQuestionNumbers={e => {}}
                                    uploadQuestions={true}
                                    
                                />
                            </div>
                            </Scrollbars>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={(e) => this.setState({showUploadModal: false, uploadQuestions: []})}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleQuestionUpload}
                            
                        >
                            Import
                        </button>
                    </div>
                </div>
            </div>
        </div>    
        )
    }

    render () {
        return (
            <div
                className="tab-pane chapter_part_quiz_questions"
                id="chapter_part_quiz_questions"
            >
                <div className="text-right sp-10 border-bottom">
                    {this.props.questions.length > 0 &&
                        <div className="download-container">
                          <CsvDownloader
                            filename={"QuizQuestions-" + this.props.chapterVideoId}
                            columns={this.columns}
                            separator=','
                            datas={this.props.questions}
                            text="DOWNLOAD">
                            
                                <a
                                href="#download-questions"
                                className="btn btn-default"
                            >
                                <i className="zmdi zmdi-download"/> &nbsp;
                                Download Questions
                            </a>
                            </CsvDownloader>
                        </div>
                      
                    
                    }
                    &nbsp; 
                    <a
                        href="#uploadQuizQuestion"
                        data-toggle="modal"
                        className="btn btn-default"
                        onClick={e => this.setState({showUploadModal: true})}
                    >
                        <i className="zmdi zmdi-upload"/> &nbsp;
                        Upload Questions
                    </a>
                    
                    &nbsp; 
                    <a
                        onClick={this.triggerAddQuestionShowState}
                        href="#AddQuizQuestion"
                        data-toggle="modal"
                        className="btn btn-primary"
                    >
                        <i className="zmdi zmdi-plus-circle"/> &nbsp;
                        Add Question
                    </a>
                </div>
                {
                    this.state.showEditQuizModal &&
                    <EditQuizQuestionModal
                        triggerEditQuestionShowState={this.triggerEditQuestionShowState}
                        quizQuestionsProps={this.props.questions}
                        onQuizQuestionUpdate={this.props.onQuizQuestionUpdate}
                        onQuizQuestionAdd={this.props.onQuizQuestionAdd}
                        saveQuizQuestion={this.props.saveQuizQuestion}
                        selectedId={this.state.selectedQuizQuestionId}
                        deleteQuestionFile={this.props.deleteQuestionFile}
                        user={this.props.user}
                    />
                }
                
                {this.renderQuizQuestionsItems()}
                {
                    this.state.deleteModalIsOpen &&
                    this.renderDeleteModal(this.state.selectedQuizQuestionId)
                }
                
                
                {this.state.showUploadModal &&
                    this.renderUploadModal()
                }
            </div>
        )
    }
}

EditQuizQuestions.propTypes = {
    getTimeToRewind: PropTypes.func,
    onLoad: PropTypes.func.isRequired,
    onQuizQuestionAdd: PropTypes.func.isRequired,
    onQuizQuestionDelete: PropTypes.func.isRequired,
    onQuizQuestionUpdate: PropTypes.func.isRequired,
    quizQuestions: PropTypes.array.isRequired,
};

export default EditQuizQuestions;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/EditQuizQuestions.js